import type { ReactNode } from "react";
import { QrCode } from "@safers/ui/atoms";

interface Props {
  title: string;
  description: ReactNode;
}

/**
 * 현장(uuid)을 잡지 못했을 때 보여 주는 전체 화면
 */
export function SiteUnavailableScreen({ title, description }: Props) {
  return (
    <main className="flex min-h-screen items-center justify-center bg-slate-100 p-6 pt-[calc(1.5rem_+_env(safe-area-inset-top))]">
      <div className="w-full max-w-sm rounded-3xl bg-white p-8 text-center shadow-sm">
        <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-2xl bg-brand/10 text-brand">
          <QrCode size={40} aria-hidden />
        </div>

        <h1 className="mt-6 text-lg font-bold text-neutral-800">{title}</h1>
        <p className="mt-2 text-sm leading-relaxed text-neutral-500">{description}</p>

        <div className="mt-6 flex items-start gap-2.5 rounded-2xl bg-slate-100 p-3.5 text-left">
          <span
            aria-hidden
            className="flex h-5 w-5 flex-none items-center justify-center rounded-full bg-neutral-300 text-[0.6875rem] font-bold text-white"
          >
            ?
          </span>
          <p className="text-xs leading-relaxed text-neutral-500">
            다시 스캔해도 열리지 않으면{" "}
            <b className="font-semibold text-neutral-700">현장 관리자</b>에게 문의해 주세요.
          </p>
        </div>
      </div>
    </main>
  );
}
